<template>
  <section class="post-recents">
    <div :class="!isMobile() ? 'container' : 'row crsl-mobile'">
      <div class="block-header">
        <h2 v-text="translate.titleBlog"></h2>
        <p>
          {{ translate.subtitleBlog }}
        </p>
        <NuxtLink :to="{
          name: 'language-blog',
          params:{
            language: route.params.language
          }
        }" class="button button--o">
          {{ translate.goToBlog }}
          <font-awesome
            :icon="['fas', 'arrow-right']"
            size="lg"
            style="margin-left: 10px"
          />
        </NuxtLink>
      </div>
      <BlockBlack :styles="BlackIsMobile()" />
      <div class="list__cards">
        <div class="model-list model-list--home">
          <swiper
            :slidesPerView="'auto'"
            :spaceBetween="10"
            :pagination="{ dynamicBullets: true, clickable: true }"
            :breakpoints="{
              '769': {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              '1000': {
                slidesPerView: 3,
                spaceBetween: 20,
              },
            }"
            :modules="modules"
            class="mySwiper"
            ref="swiperBlogs"
            style="
              --swiper-pagination-color: black;
              --swiper-pagination-bullet-inactive-color: black;
              --swiper-pagination-bullet-size: 12px;
              --swiper-pagination-bottom: 0px;
            "
          >
            <swiper-slide v-for="(post, index) in postBlogDesktop" :key="index">
              <PostListItem :posts="post" :homepage="true" />
            </swiper-slide>
          </swiper>
          <br>
          <swiper
            :slidesPerView="'auto'"
            :spaceBetween="10"
            :pagination="{ dynamicBullets: true, clickable: true }"
            :breakpoints="{
              '769': {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              '1000': {
                slidesPerView: 3,
                spaceBetween: 20,
              },
            }"
            :modules="modules"
            class="mySwiper swiper-mobile"
            ref="swiperBlogs"
            style="
              --swiper-pagination-color: black;
              --swiper-pagination-bullet-inactive-color: black;
              --swiper-pagination-bullet-size: 12px;
              --swiper-pagination-bottom: 0px;
            "
          >
            <swiper-slide v-for="(post, index) in postBlogMobile" :key="index">
              <PostListItem :posts="post" :homepage="true" />
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import BlockBlack from "@/components/BlocksCustom/BlockBlack.vue";
import { isMobile } from "@/shared/utils/mobile";
import PostListItem from "./PostListItem.vue";
import translateMain from "@/tradutors/menu";

const route = useRoute()

// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

// import required modules
import { Pagination } from "swiper/modules";

const modules = [Pagination];

const props = defineProps(["postBlogs", "path2"]);
const translate = computed(() =>
  route.params.language === "pt-br"
    ? translateMain.portugues
    : translateMain.ingles
);

const postBlogDesktop = ref([]);
const postBlogMobile = ref([]);
watch(
  () => props.postBlogs,
  () => {
    postBlogDesktop.value = isMobile() ? props.postBlogs.slice(0, 6) : props.postBlogs.slice(0, 3)
    postBlogMobile.value = props.postBlogs.slice(3, 6);
  },
  { immediate: true }
);

function BlackIsMobile() {
  return isMobile() ? { height: "140px" } : { height: "110px" };
}
</script>

<style scoped lang="css">
.button--o {
  color: #000000;
  font-family: "Exo-2";
  font-size: 16px;
  letter-spacing: 0;
  text-align: right;
  background-color: white;
  padding-left: 47px;
  padding-right: 49px;
}

.button--o svg {
  color: #b20000;
}

.list-cards-mobile {
  display: none;
}

h2 {
  height: 77px;
  color: #ffffff;
  font-family: "Bebas-Neue-Light";
  font-size: 64px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 77px;
}

.block-header p {
  color: #ffffff;
  font-family: "Roboto-Medium";
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 21px;
}

.block-header {
  margin-bottom: 6px;
  justify-content: center;
  padding-top: 20px;
}

.list__cards {
  margin-top: -60px;
}

.model-list--home {
  position: absolute;
  width: 100%;
}

.swiper-mobile {
  display: block;
}

@media screen and (max-width: 1040px) {
  .block-header p {
    display: none;
  }
}

@media screen and (max-width: 769px) {
  .swiper-mobile {
    display: none;
  }

  .list__cards {
    margin-top: 0;
    order: 3;
    left: -3px;
  }

  .container,
  .crsl-mobile {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    background: linear-gradient(to bottom, #000 0, #000 159px, #F0F0F0 159px);
    padding-bottom: 180px;
    margin-bottom: -170px;
    position: relative;
    z-index: 0;
  }

  .block-header {
    display: contents;
  }

  .block-header h2 {
    order: 1;
    margin-right: 0px;
    text-align: center;
    width: 100%;
    margin-bottom: 10px;
  }

  .block-header p {
    order: 1;
  }

  :deep(.block-dark) {
    display: none;
  }

  .block-header a.button--o {
    order: 4;
    display: inline-flex;
    align-self: center;
    left: auto;
    transform: none;
    color: #ffffff;
    background-color: #000000;
    border: none;
    width: auto;
    max-width: max-content;
    position: relative;
    z-index: 1;
    padding-left: 20px;
    padding-right: 20px;
  }

  .model-list--home {
    position: static;
    margin-top: 0;
    padding-bottom: 40px;
  }

  :deep(.card) {
    background-color: transparent;
  }

  :deep(.card-body) {
    text-align: center;
  }

  :deep(.card-title),
  :deep(.card-title-mobile),
  :deep(.card-text span),
  :deep(.button--more) {
    color: #ffffff;
    text-align: center;
  }

  :deep(.card-title) {
    color: #b20000;
    font-weight: 600;
    font-size: 17px;
  }

  :deep(.card-text span) {
    color: #1D1D1D;
    font-weight: 300;
    font-size: 15px;
  }

  :deep(.button--more) {
    display: none;
  }

  :deep(.mySwiper) {
    --swiper-pagination-color: #000000 !important;
    --swiper-pagination-bullet-inactive-color: #000000 !important;
    width: 105%;
  }

  h2 {
    height: 58px;
    color: #ffffff;
    font-family: "Bebas-Neue-Light";
    font-size: 48px;
    font-weight: 300;
    letter-spacing: 0;
    line-height: 58px;
  }

  .swiper-slide {
    width: 85% !important;
  }

  .container {
    /* padding-right: 0px; */
    padding-left: 15px;
  }

  .crsl-mobile {
    margin-left: 0px;
    margin-right: unset;
  }
}

/* === Tablet/iPad (770–1199px) === */
@media screen and (min-width: 770px) and (max-width: 1199px) {
  h2 {
    height: auto;
    font-size: 44px;
    line-height: 1.1;
  }

  /* Replica o fundo do desktop: preto no topo (header + metade superior das imagens
     da 1ª linha) e branco atrás do resto (metade inferior da linha 1 + linha 2).
     Os cards entram no fluxo (relative) para a seção crescer e conter as 2 linhas,
     empurrando a seção VÍDEOS para baixo (o espaçador BlockWhite é ocultado no
     index.vue nesta faixa). O arredondamento final fica por conta do .videos-gray-cap.
     Mesma técnica já usada no mobile (gradiente em 159px). */
  .post-recents {
    background: linear-gradient(to bottom, #000 0, #000 235px, #fff 235px);
  }
  .model-list--home {
    position: relative;
  }
}
</style>
